<section class="fxt-template-animation fxt-template-layout4 loaded">
    <div class="container-fluid" style="height: calc(100vh - 32px);padding: 0px; overflow: auto;">
        <div class="d-flex flex-wrap flex-sm-column flex-column flex-md-column flex-lg-column flex-xl-row resp-height">
            <div class="col-xl-7 col-lg-7 col-md-12 col-sm-12 col-7 pd-l-0 pd-r-0 tel">
                <div id="cf3" class="col-12" style = "height: 100%; width: 100%;">
                    <img src="assets/Agora-new-login-page-version-1-left.jpg" class="lft-img-align bottom" style = "height: 100%; width: 100%;"/>
                    <img src="assets/Agora-new-login-left-img-2.jpg" class="lft-img-align top" style = "height: 100%; width: 100%;"/>
                    <div class="banner-cntnt-align col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                        <div class="fxt-transformY-50 fxt-transition-delay-2">
                            <h1>Effective meetings without the hassle!</h1>
                        </div>
                        <div class="fxt-transformY-50 fxt-transition-delay-3">
                            <p class="p-banner-info">Revamp the way you have meetings with powerful electronic tools to
                                facilitate
                                meetings.
                            </p>
                        </div>
                        <div class="fxt-transformY-50 fxt-transition-delay-3">
                            <p class="p-banner-info">
                                The perfect way to organize and keep track of your meetings and meeting notes.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div *ngIf="showSignIn"
                class="col-xl-5 col-lg-12 col-md-12 col-sm-12 col-12 d-flex flex-column justify-content-center mar-" style="margin-bottom: 140px;">
                <div class="col-12 text-center logo-style">
                    <img src='assets/Agora logo.png' class="logo-img p-10 agora-logo-size" />
                </div>
                <div class="col-12 text-center adc-pt15">
                    <h2 class="margin-0 p-10" style="font-size: 2.5em;">Login</h2>
                </div>
                <div class="col-12">
                    <div class="fxt-form p-10">
                        <form [formGroup]="loginForm" (ngSubmit)="onLoginApp()" novalidate class="padding-remove">
                            <div class="example-container">
                                <div>
                                    <mat-form-field class="example-full-width log login-btns" style="width: 100%">
                                        <mat-label class="log-label">User Name<span class="asterik-class">&nbsp;*</span>
                                        </mat-label>
                                        <input matInput formControlName="userName"
                                            [ngClass]="{ 'is-invalid': submitted && f.userName.errors }">
                                        <mat-icon matPrefix class="pre-icn-align mat-icon-menu">mail_outline</mat-icon>
                                        <mat-error *ngIf="checkError('userName', 'required')">User Name is required
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                                <div>
                                    <mat-form-field class="example-full-width log login-btns" style="width: 100%">
                                        <mat-label>Password<span class="asterik-class">&nbsp;*</span></mat-label>
                                        <input matInput type="password" formControlName="password"
                                            [ngClass]="{ 'is-invalid': submitted && f.password.errors }">
                                        <mat-icon matPrefix class="pre-icn-align mat-icon-menu">lock_open</mat-icon>
                                        <mat-error *ngIf="checkError('password', 'required')">Password is required
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                                <p class="body-font-size error" *ngIf="showValidator" [innerHTML] = "errorMessage"></p>
                                <div
                                    class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 d-flex justify-content-between align-items-center">
                                    <div class="col-md-8 col-sm-8 col-8 col-lg-8 col-xl-8" style="text-align: initial;">
                                        <span class="fsize-15">
                                            <a (click)="showWorkingAlert()" class="switcher-text cursor-pointer f-bold">Forgot
                                                Password?</a>
                                        </span>
                                    </div>
                                    <button mat-raised-button color="primary" class="fxt-btn-fill text-uppercase">Login</button>

                                </div>
                            </div>
                        </form>
                        <div class="new_user w-100 d-flex justify-content-center" style="margin-top: 2rem;">

                            <span class="fsize-15 f-left cursor-pointer">
                                <p class="p-10">Don't have an account?&nbsp;&nbsp;
                                    <mat-icon class="fs-6">exit_to_app   </mat-icon>
                                    <a (click)="showSignUpDiv(true)"
                                        class="switcher-text2 inline-text f-bold">Sign Up
                                    </a></p>
                            </span>

                        </div>

                        <div class="new_user w-100 d-flex justify-content-center" style="margin-top: 5px;">

                            <div class="text-center">
                                <p>Explore more about Agora, 
                                    <mat-icon class="fs-6">ondemand_video</mat-icon>
                                    <a (click)="toggleHelpVideo()" class="switcher-text2 inline-text f-bold cursor-pointer">Help Video</a>
                                    <!-- <mat-icon>video_library</mat-icon> -->
                                </p>
                                </div>

                        </div>
                    </div>
                </div>
            </div>

            <!-- sign up  -->
            <div *ngIf="showSignUp"
                class="col-xl-5 col-lg-12 col-md-12 col-sm-12 col-12 d-flex flex-column justify-content-center mar-t">
                <div class="col-12 text-center logo-style">
                    <img src='assets/Agora logo.png' class="logo-img p-10 agora-logo-size" />
                </div>
                <div class="col-12 text-center" style="margin-bottom: 50px;">
                    <h2 class="margin-0 p-10" style="font-size: 2.5em;">Sign Up</h2>
                </div>
                <div class="col-12 padding-remove">

                    <div class="" style="overflow-y: auto; overflow-x: hidden;">

                        <div class="fxt-form p-10 text-center">
                            <div>
                                <span class="f-right mb-3">
                                    <mat-button-toggle-group name="favoriteColor" aria-label="Favorite Color">
                                        <mat-button-toggle value="red" (click)="showIndividual(true)"
                                            checked={{individualShow}}>Individual</mat-button-toggle>
                                        <mat-button-toggle value="green" (click)="showGroup(true)">Group
                                        </mat-button-toggle>

                                    </mat-button-toggle-group>
                                </span>
                            </div>
                            <div id="individual-form">
                                <form [formGroup]="userRegForm" #formDirectiveInd="ngForm"  (ngSubmit)="createNewUser()">
                                    <div class="form-group ">
                                        <mat-form-field class="example-full-width log login-btns" style="width: 100%">
                                            <mat-label>First Name<span class="asterik-class">&nbsp;*</span></mat-label>
                                            <input type="text" matInput formControlName="firstName"
                                                [ngClass]="{ 'is-invalid': isSubmitted && userRegControlsVal.firstName.errors }">
                                            <mat-icon matPrefix class="pre-icn-align mat-icon-menu">account_circle
                                            </mat-icon>
                                            <mat-error *ngIf="signUpCheckError('firstName', 'required')">First Name is
                                                required</mat-error>
                                            <!-- <input type="text" matInput formControlName="firstName"> -->
                                        </mat-form-field>
                                    </div>
                                    <div class="form-group ">
                                        <mat-form-field class="example-full-width log login-btns" style="width: 100%">
                                            <mat-label>Last Name<span class="asterik-class">&nbsp;*</span></mat-label>
                                            <input type="text" matInput formControlName="lastName"
                                                [ngClass]="{ 'is-invalid': isSubmitted && userRegControlsVal.lastName.errors }">
                                            <mat-icon matPrefix class="pre-icn-align mat-icon-menu">account_circle
                                            </mat-icon>
                                            <mat-error *ngIf="signUpCheckError('lastName', 'required')">Last Name is
                                                required</mat-error>
                                            <!-- <input type="text" matInput formControlName="lastName"> -->
                                        </mat-form-field>
                                    </div>
                                    <div class="form-group ">
                                        <mat-form-field class="example-full-width log login-btns" style="width: 100%">
                                            <mat-label>Email<span class="asterik-class">&nbsp;*</span></mat-label>
                                            <input id="emailVal" type="email" matInput (blur)="checkEmailExists('I')"
                                                formControlName="email"
                                                [ngClass]="{ 'is-invalid': isSubmitted && userRegControlsVal.email.errors }">
                                            <mat-icon matPrefix class="pre-icn-align mat-icon-menu">mail_outline
                                            </mat-icon>
                                            <mat-error *ngIf="signUpCheckError('email', 'required')">Email is required
                                            </mat-error>
                                            <mat-error *ngIf="signUpCheckError('email', 'email')">Invalid Email format
                                            </mat-error>
                                            <!-- <input type="email" matInput (blur)="checkEmailExists()" formControlName="email"> -->
                                        </mat-form-field>
                                    </div>
                                    <div class="form-group ">
                                        <mat-form-field class="example-full-width log login-btns" style="width: 100%">
                                            <mat-label>Phone Number<span class="asterik-class">&nbsp;*</span>
                                            </mat-label>
                                            <input type="text" mask="(000) 000-0000" matInput formControlName="phno"
                                                (keypress)="keyPressNumbers($event)"
                                                [ngClass]="{ 'is-invalid': isSubmitted && userRegControlsVal.phno.errors }">
                                            <mat-icon matPrefix class="pre-icn-align mat-icon-menu">settings_phone
                                            </mat-icon>
                                            <mat-error *ngIf="signUpCheckError('phno', 'required')">Phone Number is
                                                required</mat-error>
                                            <!-- <mat-error *ngIf="signUpCheckError('phno', 'minLength')">Max 9 Numbers is required</mat-error> -->
                                            <mat-error *ngIf="signUpCheckError('phno', 'pattern')">Please, Enter 10
                                                digit Mobile Number</mat-error>
                                            <!-- <input  type="text" matInput formControlName="phno"> -->
                                        </mat-form-field>

                                    </div>

                                    <div class="form-group new_userSignup">
                                        <div class="fxt-checkbox-area ">
                                            <span class="">
                                                <span><input type="checkbox" formControlName="acceptTerms"
                                                        [ngClass]="{ 'is-invalid': submitted && userRegControlsVal.acceptTerms.errors }">&nbsp;&nbsp;I
                                                    agree to the <a href="https://www.aithent.com/privacy-policy/" target="blank">Privacy Policy</a></span>
                                            </span>

                                            <mat-error *ngIf="submitted && userRegControlsVal.acceptTerms.errors">&nbsp;&nbsp;I agree to
                                                the Privacy
                                                Policy is required</mat-error>
                                        </div>
                                    </div>
                                    <button type="submit" mat-raised-button color='primary'
                                        class="btn btn-agora btn-lg cursor-pointer text-uppercase">sign up</button>
                                </form>
                            </div>
                            <div style="display: none;" id="group-form">
                                <form [formGroup]="groupUserRegForm" #formDirectiveGroup="ngForm"  (ngSubmit)="createNewGroupUser()">
                                    <!-- <form method="POST"  [formGroup]="userRegForm"> -->
                                    <div class="form-group ">
                                        <mat-form-field class="example-full-width log login-btns" style="width: 100%">
                                            <mat-label>Group Name<span class="asterik-class">&nbsp;*</span></mat-label>
                                            <input type="text" matInput id="comp_name" formControlName="companyName"
                                                (keyup)="checkGroupNameExist()" [matAutocomplete]="auto">
                                                <mat-icon matPrefix class="pre-icn-align mat-icon-menu">group
                                                </mat-icon>
                                            <mat-autocomplete #auto="matAutocomplete">
                                                <mat-option *ngFor="let option of companyExist"
                                                    (click)="selectToCheck(option)" [value]="option[0]">
                                                    {{option[0]}}
                                                </mat-option>
                                            </mat-autocomplete>
                                        </mat-form-field>
                                    </div>
                                    <div class="form-group ">
                                        <mat-form-field class="example-full-width log login-btns" style="width: 100%">
                                            <mat-label>First Name<span class="asterik-class">&nbsp;*</span></mat-label>
                                            <input type="text" matInput formControlName="firstName"
                                                [ngClass]="{ 'is-invalid': isSubmitted && groupRegControlsVal.firstName.errors }">
                                                <mat-icon matPrefix class="pre-icn-align mat-icon-menu">account_circle
                                                </mat-icon>
                                            <mat-error *ngIf="signUpCheckError('firstName', 'required')">First Name is
                                                required</mat-error>
                                            <!-- <input type="text" matInput formControlName="firstName"> -->
                                        </mat-form-field>
                                    </div>
                                    <div class="form-group ">
                                        <mat-form-field class="example-full-width log login-btns" style="width: 100%">
                                            <mat-label>Last Name<span class="asterik-class">&nbsp;*</span></mat-label>
                                            <input type="text" matInput formControlName="lastName"
                                                [ngClass]="{ 'is-invalid': isSubmitted && groupRegControlsVal.lastName.errors }">
                                                <mat-icon matPrefix class="pre-icn-align mat-icon-menu">account_circle
                                                </mat-icon>
                                            <mat-error *ngIf="signUpCheckError('lastName', 'required')">Last Name is
                                                required</mat-error>
                                            <!-- <input type="text" matInput formControlName="lastName"> -->
                                        </mat-form-field>
                                    </div>
                                    <div class="form-group ">
                                        <mat-form-field class="example-full-width log login-btns" style="width: 100%">
                                            <mat-label>Email<span class="asterik-class">&nbsp;*</span></mat-label>
                                            <input type="email" matInput (blur)="checkEmailExists('G')"
                                                formControlName="email"
                                                [ngClass]="{ 'is-invalid': isSubmitted && groupRegControlsVal.email.errors }">
                                                <mat-icon matPrefix class="pre-icn-align mat-icon-menu">mail_outline
                                                </mat-icon>
                                            <mat-error *ngIf="signUpCheckError('email', 'required')">Email is required
                                            </mat-error>
                                            <mat-error *ngIf="signUpCheckError('email', 'email')">Invalid Email format
                                            </mat-error>
                                            <!-- <input type="email" matInput (blur)="checkEmailExists()" formControlName="email"> -->
                                        </mat-form-field>
                                    </div>
                                    <div class="form-group ">
                                        <mat-form-field class="example-full-width log login-btns" style="width: 100%">
                                            <mat-label>Phone Number<span class="asterik-class">&nbsp;*</span>
                                            </mat-label>
                                            <input type="text" mask="(000) 000-0000" matInput formControlName="phno"
                                                (keypress)="keyPressNumbers($event)"
                                                [ngClass]="{ 'is-invalid': isSubmitted && groupRegControlsVal.phno.errors }">
                                                <mat-icon matPrefix class="pre-icn-align mat-icon-menu">settings_phone
                                                </mat-icon>
                                            <mat-error *ngIf="signUpCheckError('phno', 'required')">Phone Number is
                                                required</mat-error>
                                            <!-- <mat-error *ngIf="signUpCheckError('phno', 'minLength')">Max 9 Numbers is required</mat-error> -->
                                            <mat-error *ngIf="signUpCheckError('phno', 'pattern')">Please, Enter 10
                                                digit Mobile Number</mat-error>
                                            <!-- <input  type="text" matInput formControlName="phno"> -->
                                        </mat-form-field>

                                    </div>


                                    <div class="form-group new_userSignup d-flex">
                                        <div class="fxt-checkbox-area col-12">
                                            <span class="">
                                                <span><input type="checkbox" formControlName="acceptTerms"
                                                        [ngClass]="{ 'is-invalid': isSubmitted && groupRegControlsVal.acceptTerms.errors }">&nbsp;&nbsp;I
                                                    agree to the <a href="https://www.aithent.com/privacy-policy/" target="blank">Privacy Policy</a></span>
                                            </span>

                                            <mat-error *ngIf="isSubmitted && groupRegControlsVal.acceptTerms.errors"
                                                style="padding-left: 13px;">&nbsp;&nbsp;I agree to
                                                the Privacy
                                                Policy is required</mat-error>
                                        </div>
                                    </div>
                                    <div class="col-12">
                                        <button type="submit" mat-raised-button color='primary'
                                            class="btn btn-agora btn-lg cursor-pointer text-uppercase">sign
                                            up</button>
                                    </div>
                                </form>
                            </div>

                        </div>

                        <div class="form-group new_user p-t15">
                            <div class="fxt-checkbox-area float-right sign-up-footer-fix justify-content-center">
                                <p class="p-10" style="font-size: 17px;">Already a Member?&nbsp;&nbsp;<a (click)="showSignInDiv(true)"
                                        class="switcher-text2 inline-text cursor-pointer f-bold">Login</a>
                                </p>

                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <!--Forget Password-->
            <div *ngIf="showForgetPasswordDiv"
                class="col-xl-5 col-lg-12 col-md-12 col-sm-12 col-12 d-flex flex-column justify-content-center mar-t">
                <div class="col-12 text-center logo-style">
                    <img src='assets/Agora logo.png' class="logo-img p-10 agora-logo-size" />
                </div>
                <div class="col-12 text-center" style="padding-top: 2rem;">
                    <h2 class="margin-0 p-10" style="font-size: 2.5em;">Forgot Password</h2>
                </div>
                <div class="">

                    <div class="fxt-form p-10">
                        <form [formGroup]="forgetPassword" (ngSubmit)="onSubmitForgetPassword()" class="padding-remove">
                            <div class="example-container forgot-password">
                                <div>
                                    <mat-form-field class="example-full-width log login-btns forgot-user" style="width: 100%">
                                        <mat-label>User Name<span class="asterik-class">&nbsp;*</span></mat-label>
                                        <!-- <input matInput formControlName="userName"> -->
                                        <input matInput formControlName="userName" (blur)="triggerSecurityQuestions()"
                                            [ngClass]="{ 'is-invalid': forgetPasswordSubmitted && m.userName.errors }">
                                        <mat-icon matPrefix class="pre-icn-align mat-icon-menu">account_circle
                                        </mat-icon>
                                        <mat-error *ngIf="forgetPasswordError('userName', 'required')">User Name is
                                            required</mat-error>
                                    </mat-form-field>
                                </div>
                                <div  formArrayName="questionContainer" *ngIf="showSecurityQuestions">
                                    <div *ngFor = "let item of securityQuestions.controls; let i = index"  [formGroupName]="i">
                                      <!-- <div *ngFor = "let item of [].constructor(questionPolicyLength); let i = index" [formGroupName]="i"> -->
                                        <mat-form-field  class="example-full-width login-btns2 security" style="width: 100%">
                                          <mat-label class="d-flex" style="left: 0px !important">Security Question {{i+1}} <span class="asterik-class">&nbsp;^</span></mat-label>
                                          <mat-select disableOptionCentering panelClass="common-drop-down-class" formControlName="quesCode" id = "dpdown" (selectionChange)="FieldValidation()">
                                            <ng-container *ngFor = "let items of questions;let inner = index">
                                                <mat-option *ngIf = "inner == i" disabled value={{items.quesCode}} >{{items.question}}</mat-option>
                                                  
                                            </ng-container>
            
                                          </mat-select>
                                        </mat-form-field>
                                        <mat-form-field  class="example-full-width sec-answer" style="width: 100%" [floatLabel]="'always'">
                                          <mat-label>Answer {{i+1}} <span class="asterik-class">&nbsp;^</span></mat-label>
                                          <input formControlName="quesAnswer" id = "answer" type="password" matInput (click)="$event.stopPropagation()" (keyup)="FieldValidation()">
                                        </mat-form-field>
                                    </div>
                                  </div>
                                  <p *ngIf = "showSecurityQuestions" class="text-center" style="margin-top: 10px; margin-bottom: 30px;"><em><b>(OR)</b> please use email if you forgot security question <u class="pointer ind" (click)="hideSecurityQuestions(false)">e-mail</u></em></p>
                                  <div class="m-b-0" style="margin-top: 15px;">
                                    <mat-form-field  class="example-full-width log forgot-user login-btns" style="width: 100%">
                                      <mat-label>Email<span class="asterik-class">&nbsp;^</span></mat-label>
                                      <mat-icon matPrefix class="pre-icn-align mat-icon-menu">mail_outline
                                    </mat-icon>
                                      <input matInput type="email" formControlName="email"  (keyup)="FieldValidation()">
                                      <!-- <input matInput type="email" formControlName="email"> -->
                                      <!-- <mat-error *ngIf="forgetPasswordError('email', 'required')">Email is required</mat-error>
                                      <mat-error *ngIf="forgetPasswordError('email', 'email')">Invalid Email format</mat-error> -->
                                        <!-- <mat-error *ngIf="forgetPasswordError('email', 'required')">Email is
                                            required</mat-error> -->
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="d-flex justify-content-center col-12">
                                <div class="col-8 text-center">
                                    <button type="submit" mat-raised-button color='primary'
                                        class="btn btn-agora cursor-pointer text-uppercase">submit</button>
                                </div>
                            </div>
                        </form>
                        <div class="form-group new_user p-t15">
                            <div class="fxt-checkbox-area float-right d-flex justify-content-center forget-pass-footer-fix">
                                <p style="font-size: 17px;">Already a Member?&nbsp;&nbsp;<a (click)="showSignInDiv(true)"
                                        class="switcher-text2 inline-text cursor-pointer f-bold">Login</a>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
